export const IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';

export function getNewEmptyIframe(): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  iframe.width = '1px';
  iframe.height = '1px';
  iframe.style.opacity = '0';
  iframe.style.position = 'absolute';

  return iframe;
}

export function getOriginFromUrl(url: string): string {
  return new URL(url).origin;
}

export function getCurrentPageRootUrl(): string {
  const { protocol, hostname } = window.location;

  return `${protocol}//${hostname}`;
}

export function attachMessageHandler(handler: (e: MessageEvent) => boolean | void): void {
  const handlerWrapper = (e: MessageEvent) => {
    if (handler(e)) {
      window.removeEventListener('message', handlerWrapper);
    }
  };

  window.addEventListener('message', handlerWrapper, false);
}
